"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _getRouteRecordLocation = require("../../builder/RouteRecord/getRouteRecordLocation");

var _locationToURL = require("../../util/locationToURL");

var _RouteContext = require("../contexts/RouteContext");

var _useNavigate = require("../hooks/useNavigate");

var _getNavigationBaseLocation = require("../logic/getNavigationBaseLocation");

/**
 * Renders an <a> element to given route.
 */
const RawLink = ({
  route,
  match,
  ...props
}, ref) => {
  const parentRoute = (0, _react.useContext)(_RouteContext.RouteContext);
  const navigate = (0, _useNavigate.useNavigate)();
  const href = (0, _react.useMemo)(() => {
    const baseLocation = (0, _getNavigationBaseLocation.getNavigationBaseLocation)(parentRoute, route);
    const location = (0, _getRouteRecordLocation.getRouteRecordLocation)(route, match || {}, baseLocation);
    return (0, _locationToURL.locationToURL)(location);
  }, [route, match, parentRoute]);
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    ref: ref,
    href: href,
    onClick: e => {
      if (!isModifiedEvent(e)) {
        e.preventDefault(); // eslint-disable-next-line @typescript-eslint/no-explicit-any

        navigate(route, match);
      }
    }
  }, props));
};

const Link = /*#__PURE__*/(0, _react.forwardRef)(RawLink);
exports.Link = Link;

function isModifiedEvent(event) {
  return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
}